
















































































import { Component, Vue, Prop, Mixins, Watch } from 'vue-property-decorator'
// import memberOrDeptSelect from '@/components/commonForm/memberOrDeptSelect.vue'
import widgetCommon from './widgetCommon'
import {selectE} from './types'
import {difference, intersection} from 'lodash'
import widgetPop from './widgetPop'
import {AppModule} from '@/store/modules/app'
@Component({
  components: {
    // memberOrDeptSelect
  }
})
export default class extends Mixins(widgetCommon, widgetPop) {
  private popupValue: any = ''
  private indexBar: any = []
  private currentDepId = 0
  private deps: any = []
  private searchValue = ''
  private options = []
  private isFilter = false
  private get currentSelect () {
    let values = this.form[this.item.businessId]
    if (values) {
      return values.split(',').map((item) => {
        return AppModule.deptMap[item] || {}
      })
    }
    return []
  }
  private get deptList () {
    let deptList = []
    let obj = {...AppModule.deptList[0]}
    obj.departmentName = '全部部门'
    return [obj]
  }
  private get popupValueArr () {
    if (!this.popupValue) {
      return []
    }
    let v: any = []
    if (this.item.selectType === selectE.radio) { 
      v = [this.popupValue]
    } else {
      v = this.popupValue
    }
    return v.map((item) => {
      return AppModule.deptMap[item]
    })
  }
  private get componentType () {
    return this.item.selectType === 2 ? 'van-checkbox' : 'van-radio'
  }
  public mounted () {
    if (this.type === 'record') {
      this.initField()
      // 所有字段都初始化后再获取动态字段的值
      // this.$nextTick(() => {
      //   this.getDynamicValue()
      // })
    }
  }
  @Watch('searchValue')
  private search (val) {
    let searchArr = []
    if (val) {
      let list = this.options || []
      this.indexBar = []
      this.searchRecursion(list, val, searchArr)
      this.deps = searchArr
    } else if (this.isFilter) {
      this.indexBar = []
      this.deps = this.options
    } else {
      this.indexBar = [this.deptList[0]]
      this.deps = this.indexBar[0].children
    }
  }
  private searchRecursion (arr, val, searchArr) {
    arr.filter((item) => {
      if (item.departmentName.includes(this.searchValue)) {
        searchArr.push({id: item.id, departmentName: item.departmentName, path: this.getPath(item.id)})
      }
      if (item.children) {
        this.searchRecursion(item.children, val, searchArr)
      }
    })
  }
  private getPath(id) {
    let arr: string[] = []
    let depMap = AppModule.deptMap
    let current = depMap[id] || {}
    while (current.parentId) {
      let pNode: any = depMap[current.parentId]
      if (pNode && pNode.parentId !== 0) {
        arr.unshift(pNode.name)
        current = pNode
      } else {
        break
      }
    }
    return arr.join('/')
  }
  private jumpTo (item, index) {
    if (index === this.indexBar.length - 1) {
      return
    }
    this.deps = item.children
    this.indexBar = this.indexBar.slice(0, index + 1)
  }
  private changIndex (item) {
    if (item.children) {
      this.deps = item.children
      this.indexBar.push(item)
    }
  }
  private close (item) {
    if (this.item.selectType === selectE.radio) { 
      this.popupValue = ''
    } else {
      let id = item.id + ''
      let index = this.popupValue.indexOf(id)
      this.popupValue.splice(index, 1)
    }
  }
  private comfirm () {
    if (this.item.selectType === selectE.radio) { 
      this.form[this.item.businessId] = this.popupValue
    } else {
      this.form[this.item.businessId] = this.popupValue.join(',')
    }
    this.changeStatus(false)
  }
  private open () {
    if (this.disabled) {
      return 
    }
    this.filterDeptList()
    this.changeStatus(true)
    if (this.item.selectType === selectE.radio) { 
      this.popupValue = this.form[this.item.businessId]
    } else {
      let v = this.form[this.item.businessId]
      this.popupValue = v ? v.split(',') : []
    }
  }
  private clear () {
    if (this.item.selectType === selectE.radio) { 
      this.popupValue = ''
    } else {
      let v = this.form[this.item.businessId]
      this.popupValue = []
    }
  }
  // private getDynamicValue () {
  //   let {dynamicValue = ''} = this.item.defaultValue || {}
  //   dynamicValue = dynamicValue.split(',')
  //   dynamicValue.forEach((businessId) => {
  //     this.$watch('form.' + businessId, (newV, oldV = '') => {
  //       if (this.isUndef(newV)) {
  //         return
  //       }
  //       newV = newV.split(',').filter(item => item)
  //       if (this.item.selectType === selectE.radio) {
  //         this.form[this.item.businessId] = newV[0] || ''
  //       } else {
  //         oldV =  oldV.split(',').filter(item => item)
  //         let remove: string[] = difference(oldV, newV)
  //         let value = this.form[this.item.businessId] || ''
  //         let valueArr = value.split(',').filter(item => item)
  //         newV.forEach((id) => {
  //           if (!valueArr.includes(id)) {
  //             valueArr.push(id)
  //           }
  //         })
  //         remove.forEach((id) => {
  //           let index = valueArr.indexOf(id)
  //           if (index !== -1) {
  //             valueArr.splice(index, 1)
  //           }
  //         })
  //         this.form[this.item.businessId] = valueArr.join(',')
  //       }
  //     }, {immediate: this.state === 'add'})  
  //   })
  // }
  private getPathIds(id) {
    let arr: number[] = []
    let depMap = AppModule.deptMap
    let current = depMap[id] || {}
    while (current.parentId) {
      let pNode: any = depMap[current.parentId]
      if (pNode && pNode.parentId !== 0) {
        arr.unshift(Number(current.parentId))
        current = pNode
      } else {
        break
      }
    }
    return arr
  }
  // 根据条件筛选
  private filterDeptList () {
    let {dept = [], diy = []} = this.item.optionalScope || {}
    this.isFilter = false
    this.indexBar = [this.deptList[0]]
    this.deps = this.indexBar[0].children
    this.options = this.indexBar[0].children
    if (dept.length || diy.length) {
      let diyList: any[] = []
      diy.forEach((id) => {
        let v = this.form[id] ? this.form[id].split(',').map((depId) => Number(depId)) : []
        diyList = diyList.concat(v)
      })
      this.isFilter = true
      let arr: any = []
      let departmentMap = AppModule.deptMap
      let allDep = [...new Set([...diyList, ...dept])]
      Object.keys(departmentMap).forEach((id) => {
        let path = this.getPathIds(id)
        if (intersection([...path, Number(id)], allDep).length) {
          let deptObj = departmentMap[id]
          if (deptObj) {
            arr.push({id: deptObj.id, departmentName: deptObj.name, path: path.map((item) => {
              return departmentMap[item].name
            }).join('/')})
          }
        }
      })
      this.indexBar = []
      this.deps = arr
      this.options = arr
    }
  }
  private initField () {
    if (!this.isUndef(this.form[this.item.businessId])) {
      return
    }
    let {fixedValue = ''} = this.item.defaultValue || {}
    fixedValue = fixedValue ? fixedValue.split(',') : []
    if (this.item.selectType === selectE.radio) {
      this.form[this.item.businessId] = fixedValue[0] || ''
    } else {
      this.form[this.item.businessId] = fixedValue.join(',')
    }
  }
}
